import React, { useEffect, useRef, useState } from "react";
import viewBg from "assets/images/common/others/viewBg.png";
import { ReactComponent as DeleteIconSvg } from "assets/images/common/svgs/delete.svg";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { ReactComponent as ArrowDownIcon } from "assets/images/common/svgs/ArrowDownIcon.svg";
import cardImg from "assets/images/common/others/cardImg.png";
import eventImage from "assets/images/common/others/exploreEvents.png";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import ProfileUSer from "assets/images/common/others/profile-user-img.png";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUtils from "hooks/useUtils";
import { useSelector } from "react-redux";
import useUsers from "containers/user-management/useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import PersonalInformation from "./component/PersonalInformation";
import OperatingHours from "./component/OperatingHours";
import useTeamMembers from "containers/team-management/useHooks";

interface Tab {
  name: string;
  Component: JSX.Element;
}

const ViewTeamMember = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>({});
  const [data, setData] = useState<any[]>([]);
  const { getTeamMemberByID } = useTeamMembers();
  const { getQueryParams } = useUtils();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const params = getQueryParams();

  const formatDateTime = (dateTimeString: string): string => {
    const date = new Date(dateTimeString);
    const day = date.getDate();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    const minuteStr = minutes < 10 ? `0${minutes}` : minutes;

    return `${day} ${month} ${year} at ${hours}.${minuteStr} ${ampm}`;
  };

  useEffect(() => {
    getTeamMemberByID(params?.id, setUser);
  }, []);

  console.log(user);

  //   useEffect(() => {
  //     if (user?.user?.id) {
  //       getEventByUserID(
  //         { attendeeId: user?.user?.id, status: EVENT_STATUS.JOINED },
  //         setData
  //       );
  //     }
  //   }, [user?.user?.id]);

  const tabs: Tab[] = [
    {
      name: "Personal Information",
      Component: <PersonalInformation memberData={user} />,
    },
    { name: "Operating Hours", Component: <OperatingHours teamMemberId={user?.id} /> },
  ];
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  const goToBack = () => {
    navigate(-1);
  };

  const goToAllEvent = (id: number, user: any) => {
    navigate(`${siteRoutes.attendeeEvents}?id=${id}`, { state: { user } });
  };

  const goToEventDetail = (id: number, user: any) => {
    navigate(`${siteRoutes.attendeeEventsDetail}?id=${id}`, {
      state: { user },
    });
  };

  return (
    <div className="pb-5">
      <div className="flex justify-between items-center gap-4 ">
        <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
          <span
            onClick={goToBack}
            className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
          >
            <ArrowBackIcon />
          </span>
           {`${user?.firstName} ${user?.lastName}`}’ Profile
        </h1>
        {/* <div className="flex items-center gap-6">
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-primaryText">Block User</p>
            <label className="switch-field-small">
              <input type="checkbox" />
              <span className="slider"></span>
            </label>
          </span>
          <span className="flex items-center gap-2">
            <p className="text-sm font-bold text-redtext">Delete User</p>
            <DeleteIconSvg />
          </span>
        </div> */}
      </div>
      <div className="flex flex-wrap lg:flex-nowrap gap-4">
        {/* <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg min-w-[286px] max-w-[286px]">
          <div className="flex justify-center items-center gap-2 p-6 border-lightBorder border-b">
            <span>
              <img
                className="min-w-[82px] min-h-[82px] rounded-full"
                src={
                  user?.user?.profilePicUrl
                    ? concatPathWithBackendUrl(
                        user?.user?.profilePicUrl?.fileDownloadUri
                      )
                    : editProfilePicUser
                }
              />
            </span>
            <span>
              <h2 className="text-base whitespace-nowrap font-bold text-primaryText whitespace-pre-wrap">
                {`${user?.firstName} ${user?.lastName}`}
              </h2>
              <p className="text-xs font-medium text-primaryText">
                {user?.currentRole}
              </p>
            </span>
          </div>
          <div className="flex flex-col gap-2 p-6 border-lightBorder border-b">
            <span className="text-lightBlueColor font-bold text-center">
              {user?.firstName}'s Details
            </span>
            <div className="flex flex-col items-center gap-2 mt-4">
              <span className="text-xs font-bold text-center">
                Assigned Access
              </span>
              <div className="flex flex-wrap gap-2 justify-center  mt-2">
                <button className="text-[10px] px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                  RSVP’s
                </button>
                <button className="text-[10px] px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                  Hosts
                </button>
                <button className="text-[10px] px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                  Ambassadors
                </button>
                <button className="text-[10px] px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                  Badges Management
                </button>
                <button className="text-[10px] px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                  Resource Library
                </button>
              </div>
            </div>
          </div>
          <div className=" ">
            <div className=" w-full">
              <div className="p-6 border-t border-lightBorder last:border-b-0 cursor-pointer">
                <div className="flex justify-center gap-2 items-start ">
                  <div className="min-w-10 min-h-10">
                    <img
                      className="w-10 h-10 rounded-full object-cover"
                      src={cardImg}
                      alt="eventImage"
                    />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="text-[10px] text-uiLabelText">
                      23 Mar, 2025
                    </span>
                    <span className="text-sm font-medium text-primaryText">
                      Live Welcome Session
                    </span>

                    <p className="font-medium text-uiLabelText text-xs">
                      Tuesday, 04:00 PM - 04:30 PM
                    </p>

                    <p className="font-medium text-lightBlueColor text-xs">
                      with Steve Jacob
                    </p>
                    <div className="flex flex-wrap gap-2 justify-center  mt-2">
                      <button className="text-xs px-2.5 py-2 rounded-md text-white bg-navyBlueBg">
                        Join
                      </button>
                      <button className="text-xs px-2.5 py-2 rounded-md text-uiLabelText bg-ghostGrayBg">
                        Add to Calender
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6 w-full">
          <div className=" flex flex-wrap gap-4">
            {tabs.map((tab) => (
              <button
                key={tab.name}
                className={`rounded-md px-3 py-2 font-medium text-xs transition-colors duration-300 ${
                  activeTab.name === tab.name
                    ? "bg-vibrantBlueBg text-white "
                    : "bg-warmOffWhiteBg text-mediumGrayText"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.name}
              </button>
            ))}
          </div>
          <div className="mt-4">
            {activeTab.name === "Personal Information" ? (
              <PersonalInformation memberData={user} />
            ) : activeTab.name === "Operating Hours" ? (
              <OperatingHours teamMemberId={user?.id} />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTeamMember;
